// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: gateway handler for read receipts in DMs, group DMs and server channels.

import type {GatewayHandlerContext} from '@app/features/gateway/events/EventRouter';
import ReadReceipts from '@app/features/read_state/state/ReadReceipts';

interface MessageReadReceiptPayload {
	channel_id: string;
	user_id: string;
	message_id: string;
	read_at?: string;
}

export function handleMessageReadReceipt(data: MessageReadReceiptPayload, _context: GatewayHandlerContext): void {
	ReadReceipts.handleReceipt({
		channelId: data.channel_id,
		userId: data.user_id,
		messageId: data.message_id,
		readAt: data.read_at,
	});
}
